var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoyAvatarT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_166792",
    "data-name": "Group 166792",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.929,
    height: 24,
    viewBox: "0 0 15.929 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M93.957,21.555v2.03a.414.414,0,0,1-.414.414h-15.1a.414.414,0,0,1-.414-.414v-2.03A3.857,3.857,0,0,1,81.886,17.7a2.141,2.141,0,0,0,1.8-.975,2.431,2.431,0,0,0,.344-1.516l.008-.019a5.121,5.121,0,0,1-3.162-4.732v-.162A1.276,1.276,0,0,1,79.58,9.025V6.876A7.159,7.159,0,0,1,81.5,1.651C83.72-.485,87.233-.311,89.777.832a.1.1,0,0,1,0,.19L89.11,1.3a.1.1,0,0,0,.028.2l.322.035a5.22,5.22,0,0,1,3.864,2.4.111.111,0,0,1-.013.128A3.129,3.129,0,0,0,92.457,6.2V9.025a1.269,1.269,0,0,1-1.269,1.269h-.076v.162a5.121,5.121,0,0,1-3.162,4.732l.008.019a2.43,2.43,0,0,0,.344,1.516,2.141,2.141,0,0,0,1.8.975A3.857,3.857,0,0,1,93.957,21.555Z",
    transform: "translate(-78.028 0)",
    fill: "#ffdfba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M93.957,328.193v2.028a.414.414,0,0,1-.414.413h-15.1a.414.414,0,0,1-.414-.413v-2.028a3.855,3.855,0,0,1,3.857-3.852,2.142,2.142,0,0,0,1.8-.974,3.553,3.553,0,0,0,4.618,0,2.142,2.142,0,0,0,1.8.974A3.855,3.855,0,0,1,93.957,328.193Z",
    transform: "translate(-78.028 -306.634)",
    fill: "#fe4f60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M121.737,3.922a.109.109,0,0,1-.013.127,3.125,3.125,0,0,0-.854,2.147V9.016a1.271,1.271,0,0,1-1.345,1.268V7.093a2.481,2.481,0,0,0-2.483-2.48h-5.276a2.481,2.481,0,0,0-2.483,2.48v3.191a1.275,1.275,0,0,1-1.293-1.268V6.869a7.145,7.145,0,0,1,1.924-5.219c2.217-2.134,5.73-1.959,8.275-.818a.1.1,0,0,1,0,.19l-.664.273a.1.1,0,0,0,.028.2l.322.035a5.22,5.22,0,0,1,3.865,2.395Z",
    transform: "translate(-106.439 0)",
    fill: "#42434d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M143.274,95.118a5.124,5.124,0,1,1-10.246-.162V91.766a2.482,2.482,0,0,1,2.484-2.48h5.278a2.482,2.482,0,0,1,2.484,2.48Z",
    transform: "translate(-130.188 -84.664)",
    fill: "#ffebd2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M282.681,431.883h-1.24a.413.413,0,0,1,0-.827h1.24a.413.413,0,0,1,0,.827Z",
    transform: "translate(-270.528 -408.762)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M136.984,113.265a.817.817,0,0,1-.743,1.447,5.115,5.115,0,0,1-3.214-4.749V106.61a2.469,2.469,0,0,1,.435-1.4.611.611,0,0,1,1.115.37v3.353A5.077,5.077,0,0,0,136.984,113.265Z",
    transform: "translate(-130.183 -99.508)",
    fill: "#fff3e4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    d: "M196.941,294.553a5.128,5.128,0,0,1-4.043,0,3.2,3.2,0,0,0,.058-.848l.008-.019a5.125,5.125,0,0,0,3.911,0l.008.019A3.2,3.2,0,0,0,196.941,294.553Z",
    transform: "translate(-186.955 -278.495)",
    fill: "#ffd6a6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4801",
    "data-name": "Path 4801",
    d: "M83.963,325.588a2.1,2.1,0,0,1-.616.1,3.863,3.863,0,0,0-3.873,3.839v.388a.723.723,0,0,1-.723.723h-.31a.413.413,0,0,1-.413-.413v-2.028a3.853,3.853,0,0,1,3.853-3.852,2.139,2.139,0,0,0,1.8-.974,3.577,3.577,0,0,0,.491.352A1.032,1.032,0,0,1,83.963,325.588Z",
    transform: "translate(-78.028 -306.634)",
    fill: "#ff6d7a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    d: "M258.073,325.588a2.1,2.1,0,0,0,.616.1,3.863,3.863,0,0,1,3.873,3.839v.388a.723.723,0,0,0,.723.723h.31a.413.413,0,0,0,.413-.413v-2.028a3.853,3.853,0,0,0-3.853-3.852,2.139,2.139,0,0,1-1.8-.974,3.576,3.576,0,0,1-.491.352A1.032,1.032,0,0,0,258.073,325.588Z",
    transform: "translate(-248.079 -306.634)",
    fill: "#e84857"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    d: "M118.172,1.022c-.607.25-.694.305-.9.272-3.393-.526-6.369.878-7.38,4.173h0a2.467,2.467,0,0,0-.606,1.624V9.03a.646.646,0,1,1-1.291-.015V6.868a7.151,7.151,0,0,1,1.922-5.219c2.214-2.134,5.723-1.959,8.264-.818a.1.1,0,0,1,0,.19Z",
    transform: "translate(-106.439 0)",
    fill: "#4d4e59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyAvatarT);
export default __webpack_public_path__ + "static/media/boyAvatarT.4e49099decfaeb74c91968ece7529ee8.svg";
export { ForwardRef as ReactComponent };